var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowKeyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 8,
    viewBox: "0 0 17 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9037 7.84295C16.4787 7.84295 16.9453 7.37632 16.9453 6.80137L16.9453 4.22937C16.9453 3.65442 16.4787 3.1878 15.9037 3.1878L7.99887 3.1878C7.54891 1.70598 6.18514 0.617187 4.5575 0.617187C2.56601 0.617187 0.945313 2.23788 0.945313 4.22937C0.945313 6.22226 2.56601 7.84295 4.5575 7.84295C6.18514 7.84295 7.54891 6.75415 7.99887 5.27095L10.9319 5.27095L10.9319 6.80137C10.9319 7.37632 11.3986 7.84295 11.9735 7.84295C12.5485 7.84295 13.0151 7.37632 13.0151 6.80137L13.0151 5.27095L14.8622 5.27095L14.8622 6.80137C14.8622 7.37632 15.3288 7.84295 15.9037 7.84295ZM3.02865 4.23094C3.02865 3.38657 3.71609 2.70052 4.55907 2.70052C5.40205 2.70052 6.08949 3.38657 6.08949 4.23094C6.08949 5.07393 5.40205 5.75998 4.55907 5.75998C3.71609 5.75998 3.02865 5.07393 3.02865 4.23094Z",
    fill: "#FCC417"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowKeyIcon);
export default __webpack_public_path__ + "static/media/YellowKeyIcon.437d72eff31db5b45e7c3ecca599cc87.svg";
export { ForwardRef as ReactComponent };